import { deleteFile } from 'commons/service/client/documentFile'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteDocumentPeriodFile: WriteHook<number, unknown> = (opts) =>
  useMutationManager<number, unknown>(deleteFile, opts)
